import React, { Component } from 'react'
import {CardElement, PostalElement, injectStripe} from 'react-stripe-elements';
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import { signUp } from '../../store/actions/authActions'
import {addNewPlan} from 'store/actions/billingActions';
import 'react-phone-number-input/style.css'
import SignUpForm from './SignUpForm'
import PhoneInput from 'react-phone-number-input'
import logo from "assets/img/logo-small.png";
import {Elements, StripeProvider} from 'react-stripe-elements';
import CheckoutForm from 'components/billing/CheckoutForm';
import Select from 'react-select';

const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        fontFamily: 'Open Sans, sans-serif',
        letterSpacing: '0.025em',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#c23d4b',
      },
    }
  }
};


class SignUp extends Component {
  state = {
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    company: '',
    phone: '',
    plan: ''
  }
  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }

  
  handleSubmit = (e) => {
    e.preventDefault();
    
    (async () => {

      let {token} = await this.props.stripe.createToken({name: "Name"});
      if ((token.id !== null) && (token.id !== undefined)) {

        this.props.signUp(this.state, token);
        
          let company = this.state.company;
          let email = this.state.email;
          let response = await fetch("https://construwise-qa.firebaseapp.com/confirmPay", {
              method: "POST",
              headers: {"Content-Type": "text/plain"},
              body: {'stripeToken': token.id, 'stripeTokenType': token.type, 'stripeEmail': email, 'companyName': company}
          });
  
          if (response.ok) console.log("CC verification Complete!")
          this.props.addNewPlan(this.state.plan);
        
      }
    
      })();
  }

  handlePlanChange = (e) => {
    this.setState({
      plan: e.value
    })
  }

  render() {
    const { auth, authError } = this.props;
    let options = new Array();
    
    options.push({label: "Basic Plan", value: "Basic"});
    options.push({label: "Extended Plan", value: "Extended"});
    const customControlStyles = {
      control: (base, state) => ({
        ...base,
        minHeight: 32,
        height: 32,
        width: 300,
        background: "#ffffff",
        autoWidth: true,
        
        borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
        // Overwrittes the different states of border
        borderColor: state.isFocused ? "yellow" : "green",
        // Removes weird border around container
        boxShadow: state.isFocused ? null : null,
        "&:hover": {
          // Overwrittes the different states of border
          borderColor: state.isFocused ? "yellow" : "green"
        },
        padding: "15px",
        margin: "15px",
      })
    };
    if (auth.uid) return <Redirect to='/' /> 
    return (
    
          <StripeProvider apiKey="pk_test_KC2B4WlVISn6qdsjJHZa5TeC">
            <div className="grey lighten-1" style={{position: "absolute", top: 0, left: 0, width:"100%", height:"100%"}}>
          
            <Elements>
            <SignUpForm/>
            </Elements>
          </div>
          </StripeProvider>

          
      
    )
  }
}



const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    authError: state.auth.authError
  }
}

const mapDispatchToProps = (dispatch)=> {
  return {
    signUp: (creds, token) => dispatch(signUp(creds, token)),
    addNewPlan: (planName) => dispatch(addNewPlan(planName))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp)



// WEBPACK FOOTER //
// ./src/components/auth/SignUp.js